import React, { FunctionComponent } from "react";
import { style, keyframes } from "typestyle";

const Throbber: FunctionComponent = () => (
  <div
    className={style({
      position: "relative",
      display: "inline-block",
      width: "60px",
      height: "60px",
      transform: "rotate(-90deg)",
    })}
    title="Loading…"
  >
    <svg
      viewBox="0 0 60 60"
      className={style({
        animationName: keyframes({
          "100%": { transform: "rotate(360deg)" },
        }),
        animationDuration: "2s",
        animationTimingFunction: "linear",
        animationIterationCount: "infinite",
        width: "100%",
        height: "100%",
      })}
    >
      <circle
        cx="30"
        cy="30"
        r="25"
        className={style({
          animationName: keyframes({
            "0%": {
              strokeDasharray: "1.25, 250",
              strokeDashoffset: "0",
            },
            "50%": {
              strokeDasharray: "111.25, 250",
              strokeDashoffset: "-43.75",
            },
            "100%": {
              strokeDasharray: "111.25, 250",
              strokeDashoffset: "-155",
            },
          }),
          animationDuration: "1.5s",
          animationTimingFunction: "ease-in-out",
          animationIterationCount: "infinite",
          transition: "stroke-dasharray 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
          fill: "none",
          strokeDasharray: "0, 250",
          strokeDashoffset: "0",
          strokeLinecap: "round",
          strokeWidth: "4",
          stroke: "#2196f3",
        })}
      />
    </svg>
  </div>
);

export default Throbber;
